import React, { useState } from 'react';
import Home from './Home';
import SecondPage from './SecondPage';
import './App.css';

function App() {
  const [currentPage, setCurrentPage] = useState<'home' | 'second'>('home');

  const togglePage = () => {
    setCurrentPage(currentPage === 'home' ? 'second' : 'home');
  };

  return (
    <div className="App">
      <button 
        className="page-toggle-btn" 
        onClick={togglePage}
        aria-label={`Switch to ${currentPage === 'home' ? 'info page' : 'canvas page'}`}
      >
        {currentPage === 'home' ? '📄' : '🎨'}
      </button>
      
      {currentPage === 'home' ? <Home /> : <SecondPage />}
    </div>
  );
}

export default App;
